import React, { BaseSyntheticEvent, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import { useThemes } from '@core/hooks';

const modalRoot = document.getElementById('modal') as HTMLElement;

interface ModalProps {
  onOutsideClick?: () => void;
}

const Modal: React.FC<ModalProps> = ({ children, onOutsideClick }) => {
  const modalEl = useRef(document.createElement('div'));

  const { isDark } = useThemes();

  useEffect(() => {
    const body = document.querySelector('body') as HTMLElement;

    modalRoot.appendChild(modalEl.current);
    body.style.overflowY = 'hidden';

    return () => {
      modalRoot.removeChild(modalEl.current);
      body.style.overflowY = 'auto';
    };
  }, []);

  const handleOutsideClick = ({ target }: any) => {
    if (target.className.includes('modal-wrapper') && onOutsideClick) {
      onOutsideClick();
    }
  };

  const preventDefaults = (e: BaseSyntheticEvent) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const renderWrappedChildren = () => {
    return (
      <div
        className={`modal-wrapper ${isDark ? 'modal-wrapper--dark' : ''}`}
        role="presentation"
        onClick={handleOutsideClick}
        onDragEnter={preventDefaults}
        onDrop={preventDefaults}
      >
        {children}
      </div>
    );
  };

  return ReactDOM.createPortal(renderWrappedChildren(), modalEl.current);
};

export default Modal;
